const  router = [
	{
		path: "/notice",
		component: () => import('../../../pages/notice/Index.vue'),
		meta: {title: '通知'},
		name: 'notice_index',
	}
];

export default router